export const shopify = {
  tokenHelp:
    'The token can be found under "Apps and sales channels > Develop Apps"',
  oAuthFlowHelp: "Connect my account",
  authSuccess: "Authentication successful",
  migrationSuccess: "Successfully acquired tokens from Shopify."
};
